import { createIconComponent } from '../../factory/create-icon-component';
export const ForecastIcon = createIconComponent(
  'ForecastIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 11.75C2.75 6.77944 6.77944 2.75 11.75 2.75C16.7206 2.75 20.75 6.77944 20.75 11.75C20.75 12.9914 20.4987 14.1741 20.0441 15.25C19.4029 16.7683 18.9398 17.4788 17.911 18.5325M21.75 21.75L19.2453 19.2453C18.8533 18.8533 18.6573 18.6573 18.4592 18.5811C18.2621 18.5053 18.1184 18.4925 17.911 18.5325M5.25 17.975C6.88825 19.6851 9.19477 20.75 11.75 20.75C13.6604 20.75 15.4317 20.1548 16.8887 19.1397C17.4314 18.7617 17.7027 18.5726 17.911 18.5325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.4723 9.58331V13.6389M15.4723 9.58331H11.4167M15.4723 9.58331L12.7501 12.2501L11.0102 14.0453C10.6026 14.453 10.3987 14.6568 10.1803 14.7685C9.73563 14.9958 9.20881 14.9958 8.76411 14.7685C8.54571 14.6568 8.34188 14.453 7.93421 14.0453C7.51818 13.6293 7.31016 13.4213 7.08806 13.309C6.63569 13.0803 6.10025 13.0863 5.65316 13.3252C5.43365 13.4425 5.23038 13.6551 4.82385 14.0804L2.75006 16.2501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
